import { render, staticRenderFns } from "./RepresentationAddressForms.vue?vue&type=template&id=0d110cab&scoped=true"
import script from "./RepresentationAddressForms.vue?vue&type=script&lang=ts"
export * from "./RepresentationAddressForms.vue?vue&type=script&lang=ts"
import style0 from "./RepresentationAddressForms.vue?vue&type=style&index=0&id=0d110cab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d110cab",
  null
  
)

export default component.exports